import { useEffect, useState } from "react";
import { fontSize_15 } from "../../../shared/styleconfig"
import axios from 'axios';
import { VINTAGE_API } from "../../../shared/taapiConfig";

export const TopStocks = () => {

    const [topmovers, setTopMovers] = useState([]);
    const [loading, setLoading] = useState(false)
    const stocksList = [
        {
            "symbol": "NFLX",
            "price": "598.5000",
            "change_amt": "-17.3300",
            "change_percent": "-2.8141%"
        },
        {
            "symbol": "META",
            "price": "490.2200",
            "change_amt": "-7.9700",
            "change_percent": "-1.5998%"
        },
        {
            "symbol": "AMZN",
            "price": "174.1200",
            "change_amt": "-3.4600",
            "change_percent": "-1.9484%"
        },
        {
            "symbol": "GOOGL",
            "price": "132.6700",
            "change_amt": "-0.6800",
            "change_percent": "-0.5099%"
        },
        {
            "symbol": "AAPL",
            "price": "170.1200",
            "change_amt": "-4.9800",
            "change_percent": "-2.8441%"
        }
    ]

    useEffect(() => {
        setTopMovers(stocksList)
    }, []);

    return (
        <section className="flex flex-row bg-[#00163920] h-[86px] rounded-[20px] px-[10px] items-center max-w-[950px] flex-1 overflow-x-auto">
            {
                topmovers.map((item, i) => (
                    <div key={i} className="flex flex-row flex-1 gap-[7px] border-r border-r-dashed border-r-black px-[10px]  flex-wrap">
                        <div className="flex flex-col gap-[7px]">
                            <p className={`${fontSize_15} font-bold`}>
                                {item?.symbol}
                            </p>
                            <div className="flex flex-row gap-[10px]">
                                <span className={`text-[10px] text-[#63635c]`}>{parseFloat(item?.price)?.toFixed(2)}$</span>
                                <span className={`text-[10px] text-[#63635c]`}>{parseFloat(item?.change_percent)?.toFixed(2)}%</span>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <p className={`${fontSize_15} font-bold ${ item?.change_amt < 0 ? 'text-[red]' : 'text-[#50cc2b]'}`}>{parseFloat(item?.change_amt)?.toFixed(2)}$</p>
                        </div>
                    </div>
                ))
            }
        </section>
    )
}